"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { tv } from "tailwind-variants";
import cn from "../../utils/cn";
const labelVariants = tv({
    base: "text-sm font-medium text-gray-10 leading-none peer-disabled:cursor-not-allowed peer-disabled:text-gray-7",
});
const Label = React.forwardRef(({ className, ...props }, ref) => _jsx(LabelPrimitive.Root, { ref: ref, className: cn(labelVariants(), className), ...props }));
Label.displayName = LabelPrimitive.Root.displayName;
export { labelVariants };
export default Label;
